import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import Panel from '../panel'
import GameInfo from './game-info'
import TextArea from '../../inputs/text-area'
import FlashAlert from '../../../../components/flash-alert'
import { ajaxGet, patchForm } from '../../../../ajax'

export default function EditGame({league, game, formRef, onClose, onUpdate, onChanged}) {
  const { register, reset, handleSubmit, setValue, formState: { errors } } = useForm({})

  const [score, setScore] = useState()
  const [loading, setLoading] = useState(false)
  const [currentTab, setCurrentTab] = useState('Game Info')
  const [alert, setAlert] = useState(null)
  const [changes, setChanges] = useState({})

  const isInfo = currentTab == 'Game Info'
  const isNotes = currentTab == 'Notes'

  useEffect(() => {
    setCurrentTab('Game Info')
    loadScore()
  }, [game.id])

  useEffect(() => {
    if (score) reset(score)
  }, [score])

  useEffect(() => {
    onChanged(Object.values(changes).some(x => x))
  }, [changes])

  const changeValue = (name, value) => {
    setValue(name, value)
    setChanges({...changes, [name]: value != score[name] })
  }

  const loadScore = () => {
    setLoading(true)

    ajaxGet(`/admins/leagues/${league.id}/games/${game.id}/score.json`)
    .then(response => { if (response.ok) return response.json() })
    .then((json) => {
      setScore(json.score)
      setLoading(false)
    })
  }

  const prepareFormData = (data) => {
    let formData = new FormData()
    formData.append('score[team1_score]', data.team1_score)
    formData.append('score[team2_score]', data.team2_score)
    formData.append('score[notes]', data.notes)
    return formData
  }

  const clickCancel = (e) => {
    e.preventDefault()
    onClose()
  }

  const onSubmit = (data, event) => {
    if (event.target.className != 'edit-game-form') return

    setLoading(true)

    let formData = prepareFormData(data)

    patchForm(`/admins/leagues/${league.id}/games/${game.id}/score.json`, formData)
    .then(response => { return response.json() })
    .then((json) => {
      setLoading(false)
      if (json.alert)
        setAlert(json.alert)
      else {
        const score = json.score
        onUpdate({...game, team1_score: score.team1_score, team2_score: score.team2_score})
      }
    })
  }

  return <form className={'edit-game-form' + (loading ? ' isLoading' : '')} ref={formRef} onSubmit={handleSubmit(onSubmit)}>
    { loading && <div className='animated-spinner'></div> }
    <Panel tabs={['Game Info', 'Notes']} currentTab={currentTab} changeTab={(value) => setCurrentTab(value)} />
    { alert && <FlashAlert text={alert.text} type={alert.type} onHide={() => setAlert(null)} />}
    <div className='edit-game-content'>
      { score && isInfo &&
        <GameInfo
          game={game}
          register={register}
          errors={errors}
          setValue={changeValue}
        />
      }
      { score && isNotes &&
        <div className='game-notes-section'>
          <div className='section-title'>Notes</div>
          <TextArea
            {...register('notes')}
            rows='6'
            onChange={(e) => changeValue('notes', e.target.value)}
          />
        </div>
      }
      <div className='edit-game-buttons'>
        <button className='game-button button-cancel' onClick={clickCancel}>Cancel</button>
        <button className='game-button button-save' type='submit'>Save changes</button>
      </div>
    </div>
  </form>
}
